/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Download as DownloadIcon, Add as AddIcon, FilterList as FilterListIcon } from '@mui/icons-material';
import { Text, Theme, MessageCard, Button, FilterClaimsModal, Title, Container, Content, i18n, tokens } from '@simplybenefits/sb-ui-library';

import ClaimBlock from './ClaimBlock.js';
import SubmitClaim from './SubmitClaim/index.js';
import ClaimsSummaryDialog from './ClaimsSummaryDialog.js';
import { setCurrentSidebarItem } from '../../actions/user.js';
import { getClaims, createClaimsSummaryReport } from '../../actions/claims.js';
import Dial from './Dial.js';
import { numberWithCommas } from '../../services/helpers.js';
import NoBankingInfoSetUp from '../../components/NoBankingInfoSetUp.js';

class Claims extends Component {
    state = {
        submitClaimDialogOpen: false,
        filterClaimsDialogOpen: false,
        claimsSummaryDialogOpen: false,
        totalSubmitted: 0,
        totalClaimed: 0,
        totalSubmittedDialData: null,
        totalClaimedDialData: null,
        monthlyClaimsChartData: null,
        activeFilters: {},
        activeSort: false,
        amountOfActiveFilters: 0,
        isLoading: true
    };

    componentDidMount() {
        this._buildCharts(this.props.claims);

        this.props.dispatch(setCurrentSidebarItem('claims'));
    }

    componentWillUnmount = () => {
        // Clean up the filters in redux
        if (this.state.amountOfActiveFilters > 0) {
            this._resetFilters();
        }
    };

    componentWillReceiveProps(nextProps) {
        if (this.props.claims !== nextProps.claims) {
            this._buildCharts(nextProps.claims);
        }
    }

    _buildCharts = (claims) => {
        let totalSubmitted = 0;
        let totalClaimed = 0;

        // set the data
        claims.map((claim) => {
            const submitted = Number(claim.amountSubmitted);
            const claimed = claim.status.toLowerCase() === 'declined' ? 0 : Number(claim.amountPaid);

            totalSubmitted += submitted;
            totalClaimed += claimed;

            return null;
        });

        this.setState({
            totalSubmitted,
            totalClaimed,
            isLoading: false
        });
    };

    _applyFilters = (filters, sort) => {
        this.props.dispatch(getClaims(filters, sort));

        // Count all filters that are not their default value
        let amountOfActiveFilters = 0;

        amountOfActiveFilters += filters.patient === 'All Patients' ? 0 : 1;
        amountOfActiveFilters += filters.category === 'All Categories' ? 0 : 1;
        amountOfActiveFilters += filters.service === 'All Service Types' ? 0 : 1;
        amountOfActiveFilters += filters.year === 'All Years' ? 0 : 1;
        amountOfActiveFilters += !sort.sortBy ? 0 : 1;

        // set active filters to save for later
        this.setState({
            activeFilters: filters,
            activeSort: sort,
            amountOfActiveFilters
        });

        this._toggleFiltersModal(false);
    };

    _resetFilters = () => {
        this.props.dispatch(getClaims({}, false));

        this.setState({
            activeFilters: {},
            amountOfActiveFilters: 0,
            activeSort: false
        });

        this._toggleFiltersModal(false);
    };

    _createClaimsSummaryReport = (dateRange, category, service) => {
        this.props.dispatch(createClaimsSummaryReport(dateRange, category, service));

        this.setState({
            claimsSummaryDialogOpen: false
        });
    };

    _toggleClaimsSummary = () => {
        this.setState({
            claimsSummaryDialogOpen: !this.state.claimsSummaryDialogOpen
        });
    };

    _toggleSubmitClaim = () => {
        this.setState({
            submitClaimDialogOpen: !this.state.submitClaimDialogOpen
        });
    };

    _toggleFiltersModal = (value = null) => {
        this.setState({
            filterClaimsDialogOpen: value === null ? !this.state.filterClaimsDialogOpen : value
        });
    };

    render() {
        const { meta, whitelabel } = this.props;
        const claimsBlocked = meta.accountClaimsBlocked || meta.divisionClaimsBlocked || meta.memberClaimsBlocked;
        const isSpendingAccountOnly = meta.isSpendingAccountOnly === 1;
        const { isDependent } = this.props.meta;
        const styles = {
            cards: {
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                maxWidth: 1000,
                margin: 'auto'
            },
            card: {
                position: 'relative',
                width: 300,
                height: 300,
                minWidth: 280,
                minHeight: 300,
                margin: 20
            },
            filterButtonContainer: {
                maxWidth: 1000,
                display: 'flex',
                margin: 'auto',
                justifyContent: 'flex-end',
                position: 'relative',
                marginBottom: 12
            },
            claimsList: {
                maxWidth: 1000,
                display: 'block',
                margin: 'auto',
                position: 'relative',
                filter: 'drop-shadow(0px 0px 1px rgba(122, 122, 122, 0.25))' // Create elevation
            },
            titleBlock: {
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                justifyContent: "space-between",
                alignItems: 'center'
            },
            clearFiltersMessage: {
                backgroundColor: '#FFF',
                padding: '0px 20px',
                borderTop: "solid .5px #D6D6D6",
                height: 60,
                display: 'flex',
                alignItems: 'center'
            }
        };

        return (
            <Container>
                <Content>
                    <div style={ styles.titleBlock }>
                        <Title title={ i18n.t(tokens.titles["claims history"]) } customStyle={{ flex: 1 }} />
                        {
                            this.props.claims.length > 0 && !isDependent &&
                                <Button
                                    transparent
                                    customStyle={{
                                        height: 50,
                                        marginRight: 1.25,
                                        textTransform: "capitalize",
                                        fontSize: 16
                                    }}
                                    onClick={ this._toggleClaimsSummary }
                                    id="submitclaim"
                                >
                                    <DownloadIcon
                                        style={{ marginRight: 8, color: 'inherit' }}
                                    />

                                    { i18n.t(tokens.buttons["claims summary"]) }
                                </Button>
                        }

                        {
                            (!isSpendingAccountOnly && (Number(meta.paymentsSetup) === 1 || Number(meta.requiresCheque) === 1) && !meta.claimsDisabledForRollover && !claimsBlocked)
                                ? (
                                    <Button
                                        color="primary"
                                        customStyle={{
                                            height: 50,
                                            marginRight: 1.25,
                                            textTransform: "capitalize",
                                            fontSize: 16
                                        }}
                                        onClick={ () => this._toggleSubmitClaim() }
                                        id="submitclaim"
                                    >
                                        <AddIcon
                                            style={{ marginRight: 8, color: 'inherit' }}
                                        />

                                        { i18n.t(tokens.buttons.submitClaim) }
                                    </Button>
                                )
                                : null
                        }
                    </div>
                    {
                        claimsBlocked
                            ? (
                                <MessageCard
                                    title={i18n.t(tokens.titles.claimsBlocked)}
                                    subtitle={ i18n.t(tokens.labels.employees.claimsBlockedForMember) }
                                    isError={ true }
                                    small
                                />
                            )
                            : null
                    }

                    {
                        meta.claimsDisabledForRollover ?
                            <MessageCard
                                title="Claims Temporarily Disabled"
                                subtitle={ `Hi ${ meta.firstname }, claim submission is currently disabled to allow for your yearly claim usage reset. Claim submission will become active again at 12:00 PM PST.` }
                                isError={ true }
                                small
                            />
                            :
                            // Check if no payments are set up and if user is supposed to be reimbursed by cheque payments
                            (Number(meta.paymentsSetup) === 0 && Number(meta.requiresCheque) === 0) ?
                                <NoBankingInfoSetUp 
                                    isDependent={ isDependent } 
                                    addBanking={ () => this.props.history.push('/my-account') }
                                />
                                :
                                <React.Fragment>
                                    {
                                        this.props.claims.length === 0 && this.state.amountOfActiveFilters === 0 ?
                                            <MessageCard
                                                title={ i18n.t(tokens.labels.claims.noClaimHistory) }
                                                subtitle={ i18n.t(tokens.labels.claims.submitClaimButton) }
                                            />
                                            :
                                            <React.Fragment>
                                                <div style={ styles.cards }>
                                                    <div style={ styles.card }>
                                                        <Dial percentage={ ((this.state.totalClaimed / this.state.totalSubmitted) * 100) || 0 } >
                                                            <Text
                                                                extraLarge
                                                                bold
                                                                color={ whitelabel.primaryColor || Theme.colors.skyBlue}
                                                                align="center"
                                                            >
                                                                { i18n.t(tokens.labels.claims.claimed) }
                                                            </Text>

                                                            <Text largest bold margin="10px 0 0 0">{ `$${ numberWithCommas(this.state.totalSubmitted) }` }</Text>
                                                            <Text
                                                                mediumLarge
                                                                color={whitelabel.name ? Theme.colors.mediumDarkGrey : Theme.colors.brandGreen}
                                                                align="center"
                                                                margin="-10px 0 0 0"
                                                            >
                                                                { i18n.t(tokens.labels.claims.submitted) }
                                                            </Text>
                                                        </Dial>
                                                    </div>
                                                </div>

                                                <div style={ styles.filterButtonContainer }>
                                                    <Button
                                                        color={ this.state.amountOfActiveFilters > 0 ? 'primary' : 'white' }
                                                        icon="filter-outline"
                                                        onClick={ () => this._toggleFiltersModal() }
                                                        id="filterclaims"
                                                        noHover
                                                        customStyle={{
                                                            textTransform: "capitalize",
                                                            fontSize: 18
                                                        }}
                                                    >
                                                        <FilterListIcon
                                                            style={{ marginRight: 8, color: 'inherit' }}
                                                        />

                                                        {
                                                            this.state.amountOfActiveFilters > 0 ?
                                                                i18n.t(tokens.buttons.applied, { count: this.state.amountOfActiveFilters, numFilters: this.state.amountOfActiveFilters })
                                                                :
                                                                i18n.t(tokens.buttons.filter)
                                                        }
                                                    </Button>
                                                </div>

                                                <div style={ styles.claimsList }>
                                                    <ClaimBlock isHeader />
                                                    {
                                                        this.props.claims.length > 0 ?
                                                            this.props.claims.map((claim, i) => (
                                                                <ClaimBlock
                                                                    testid={i === 0 && "claimblock"}
                                                                    key={ claim.claimID }
                                                                    claimID={ claim.claimID }
                                                                    uid={ claim.uid }
                                                                    user={ claim.name }
                                                                    submitted={ Number(claim.amountSubmitted) }
                                                                    claimed={ Number(claim.amountPaid) }
                                                                    status={ claim.status }
                                                                    date={ claim.serviceDate }
                                                                    type={ claim.type }
                                                                />
                                                            ))
                                                            :
                                                            <div style={styles.clearFiltersMessage}>
                                                                <Text medium light>{ i18n.t(tokens.labels.claims.noResultsFound) }<span onClick={ this._resetFilters } style={{ textDecoration: 'underline', cursor: 'pointer' }}>{ i18n.t(tokens.labels.claims.clearFilters) }</span></Text>
                                                            </div>
                                                    }
                                                </div>
                                            </React.Fragment>
                                    }

                                    {
                                        this.state.submitClaimDialogOpen &&
                                            <SubmitClaim
                                                close={ this._toggleSubmitClaim }
                                            />
                                    }

                                    {
                                        this.state.claimsSummaryDialogOpen &&
                                            <ClaimsSummaryDialog onSave={ this._createClaimsSummaryReport } close={ this._toggleClaimsSummary }/>
                                    }

                                    {
                                        this.state.filterClaimsDialogOpen &&
                                            <FilterClaimsModal
                                                applyFilters={ this._applyFilters }
                                                close={ () => this._toggleFiltersModal() }
                                                resetFilters={ this._resetFilters }
                                                activeFilters={ this.state.activeFilters }
                                                activeSort={ this.state.activeSort }
                                                user={ this.props.meta }
                                                dependents={ this.props.dependents }
                                                hsaClaimTypes={ this.props.hsaClaimTypes }
                                                lsaClaimTypes={ this.props.lsaClaimTypes }
                                                whitelabel={ this.props.whitelabel }
                                            />
                                    }
                                </React.Fragment>
                    }
                </Content>

                <span id="claims" />
            </Container>
        );
    }
}


Claims.propTypes = {
    loading: PropTypes.bool,
    claims: PropTypes.array,
    meta: PropTypes.object,
    whitelabel: PropTypes.object
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loading: state.claims.loading,
    claims: state.claims.items,
    meta: state.user.meta,
    whitelabel: state.whitelabel,
    dependents: state.user.dependents,
    hsaClaimTypes: state.usage.data.claimTypes,
    lsaClaimTypes: state.spendingAccounts.lsaClaimTypes
});

export default connect(mapStateToProps)(Claims);